export const INQUIRY_LIMIT_REACHED_CODE = 'INQUIRY_LIMIT_REACHED';
export const INQUIRY_LIMIT_REACHED_MESSAGE =
  'You’ve reached the inquiry limit for today. You can still continue existing conversations or send an offer.';

const hasInquiryLimitCode = error => {
  if (error?.code === INQUIRY_LIMIT_REACHED_CODE) {
    return true;
  }

  const apiErrors = Array.isArray(error?.apiErrors) ? error.apiErrors : [];
  const responseErrors = Array.isArray(error?.data?.errors) ? error.data.errors : [];

  return [...apiErrors, ...responseErrors].some(
    apiError => apiError?.code === INQUIRY_LIMIT_REACHED_CODE
  );
};

export const isInquiryLimitReachedError = error => {
  return (
    hasInquiryLimitCode(error) ||
    error?.message === INQUIRY_LIMIT_REACHED_MESSAGE ||
    error?.statusText === INQUIRY_LIMIT_REACHED_MESSAGE
  );
};

export const getInquiryLimitReachedMessage = error => {
  if (!isInquiryLimitReachedError(error)) {
    return null;
  }

  return INQUIRY_LIMIT_REACHED_MESSAGE;
};
